import { priceStringFormatter } from '@fora-monorepo/string-utils';

import { MAX_NUMBER_OF_DIGITS_PAY_AMOUNT } from '../../common/constants';

export const payAmountInputFormatter = (value: string) => {
  if (!value) {
    return '';
  }

  const slicedValue = value.replace(/\D/g, '').slice(0, MAX_NUMBER_OF_DIGITS_PAY_AMOUNT);

  return priceStringFormatter(slicedValue);
};
